export const enCopywritingSettings = {
	title: "Copywriting Settings",
	description:
		"Configure account-level copywriting defaults used by the AI copywriting agent across all campaigns.",
	save: "Save",
	saved: "Settings saved successfully",
	saveError: "Failed to save settings",
	unsavedChanges: "You have unsaved changes",
	draftReplies: {
		title: "Draft Replies",
		description:
			"Controls how many AI-generated draft replies are shown as potential answers in the inbox when a new message is received.",
		label: "Draft Replies",
		information:
			'Applies to the drafts written automatically when a reply arrives. "None" writes no drafts; you can still generate a reply yourself in the inbox at any time.',
		options: {
			none: "None — no draft replies",
			one: "One — 1 draft reply",
			three: "Three — 3 draft replies",
		},
	},
	group: {
		messageStyle: "Message Style",
		messageStyleDescription: "How your messages open, close, and use subject lines.",
		contentRules: "Content Rules",
		contentRulesDescription: "Words, phrases, and calls-to-action the AI should use or avoid.",
		deliverySettings: "Delivery Settings",
		deliverySettingsDescription: "Length constraints and timing between sequence steps.",
	},
	greetingStyle: {
		title: "Greeting Style",
		description: "Define how messages should greet recipients per channel and message type.",
		channel: "Channel",
		messageType: "Message Type",
		greetingPlaceholder: "e.g. Hi {{firstName}},",
		greetingLabel: "Greeting",
		addRow: "Add greeting",
	},
	signOffStyle: {
		title: "Sign-off Style",
		description: "Default sign-off appended to outgoing messages.",
		placeholder: "e.g. Best regards,\n{{senderName}}",
	},
	emailSignature: {
		title: "Email Signature",
		label: "Add the email signature to emails (chat and campaigns)",
		description:
			"Campaign emails get the sending mailbox's signature below the message, and new email drafts start with Include signature switched on. A message that places {signature} itself, or already contains the signature, gets it only once.",
	},
	wordingBlacklist: {
		title: "Wording Blacklist",
		description: "Words or phrases the AI should never use. Press Enter to add.",
		placeholder: "Type a word or phrase and press Enter",
	},
	alternativePhrases: {
		title: "Alternative Phrases",
		description:
			"Define phrase replacements. The AI will use the replacement instead of the original.",
		originalLabel: "Original",
		replacementLabel: "Replacement",
		originalPlaceholder: "Original phrase",
		replacementPlaceholder: "Replacement phrase",
		addRow: "Add phrase",
	},
	messageLimits: {
		title: "Message Limits",
		description: "Set character and word limits per message type.",
		messageType: "Message Type",
		maxChars: "Max chars",
		minWords: "Min words",
		maxWords: "Max words",
		addRow: "Add limit",
	},
	ctaPool: {
		title: "CTA Pool",
		description: "Approved call-to-action phrases the AI can use. Press Enter to add.",
		placeholder: "Type a CTA and press Enter",
	},
	subjectLinePatterns: {
		title: "Subject Line Patterns",
		description: "Patterns or templates for email subject lines.",
		placeholder: "e.g. {{companyName}} + {{topic}} — quick question",
	},
	sendDelayDefaults: {
		title: "Send Delay Defaults",
		description:
			"New outreach steps you add to a campaign start with these delays: an email, LinkedIn message, InMail or invitation waits this many days after the previous step. The first step goes out in the next sending window, and a step with no row here waits 1 day. Steps you have already added keep their own delay.",
		step: "Step",
		delayDays: "Delay (days)",
		addRow: "Add delay",
	},
};
